
document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".product-box").forEach(box => {
    
    const mainLink = box.querySelector(".product-main-link");
    const mainImg = box.querySelector(".product-main-img");
    const thumbs = box.querySelectorAll(".variant-thumb");
    let activeThumb = box.querySelector(".variant-thumb.active");

    if (!mainImg || !mainLink || thumbs.length === 0) return;

    thumbs.forEach(thumb => {
      const variantImg = thumb.dataset.large;
      const variantID = thumb.dataset.variantId;
      const productUrl = thumb.dataset.productUrl;

      thumb.addEventListener("click", (e) => {
        e.preventDefault();
        
        thumbs.forEach(t => t.classList.remove("active"));
        thumb.classList.add("active");
        activeThumb = thumb;

        mainImg.src = variantImg;

         if (productUrl && variantID) {
          location.assign(`${productUrl}?variant=${variantID}`);
        }
      });
    });

    document.querySelectorAll('[data-bs-toggle="tooltip"]').forEach(el => {
    new bootstrap.Tooltip(el);
  });
  });
});

